import useIsOrderDisabled from "./useIsOrderDisabled";
import useAuth from "./useAuth";
import useRoles from "./user/useRoles";

export default function useIsInventoryRequestDisabled(inventoryRequest = {}) {
  const { user } = useAuth();
  const isExternalUser = useRoles(["client", "employee", "shopper", "viewer", "guest"]);
  const cutoffDisabled = useIsOrderDisabled(inventoryRequest, user?.company?.settings?.cut_off);

  const isVaStatusRestricted = isExternalUser && inventoryRequest?.vaStatus?.completed;
  const formDisabled = !user?.canEditOrders;

  return formDisabled || cutoffDisabled || isVaStatusRestricted;
}
